export default function checkWebUrl(url: string | null): string {
  if (url) {
    if (url.length < 7) return url;
    if (
      url.substring(0, 7) === 'http://' ||
      url.substring(0, 8) === 'https://'
    ) {
      return url;
    }
    return `https://${url}`;
  } else {
    return '';
  }
}
